import React from 'react';
import Modal from 'react-bootstrap/Modal';
import FormPaymentAddressInfo from './FormPaymentAddressInfo';
// import FormOfPayment from './FormOfPayment';
import FormApproveOrder from './FormApproveOrder';
import i18n from 'i18n-js';

const Checkout = (props: any) => {
  const { changeCheckoutForm, checkoutIndex, isBookingSuccess } = props;

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={props.show}
      onHide={props.onHide}
      className="box-modal-checkout-booking"
    >
      <Modal.Body>
        <div className="box-checkout-booking">
        <div>
          <p className="title">{i18n.t('order')}</p>
          <div className="btn-close" onClick={props.onHide}>
            <span>x</span>
          </div>

            <FormPaymentAddressInfo
              {...props}
              changeCheckoutForm={changeCheckoutForm}
              checkoutIndex={checkoutIndex}
            />
            <FormApproveOrder
              {...props}
              changeCheckoutForm={changeCheckoutForm}
              checkoutIndex={checkoutIndex}
            />
            {
              // <FormOfPayment
              //   {...props}
              //   changeCheckoutForm={changeCheckoutForm}
              //   checkoutIndex={checkoutIndex}
              // />
            }
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default Checkout;
